import React, { Suspense, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { CloseOutlined, ExpandOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import { Link } from 'react-router-dom';
import { getServiceComponent } from './homeServiceRegistry';
import './HomeServiceModal.css';

function HomeServiceModal({ open, service, onClose }) {
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (open) {
      setMounted(true);
      const frame = requestAnimationFrame(() => setVisible(true));
      document.body.style.overflow = 'hidden';
      return () => cancelAnimationFrame(frame);
    }

    setVisible(false);
    const timer = setTimeout(() => setMounted(false), 420);
    document.body.style.overflow = '';
    return () => clearTimeout(timer);
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  useEffect(
    () => () => {
      document.body.style.overflow = '';
    },
    [],
  );

  if (!mounted || !service) return null;

  const ServiceComponent = getServiceComponent(service.key);

  return createPortal(
    <div
      className={`home-service-modal ${visible ? 'home-service-modal--visible' : ''}`}
      role='dialog'
      aria-modal='true'
      aria-labelledby='home-service-modal-title'
    >
      <button type='button' className='home-service-modal__backdrop' onClick={onClose} aria-label='Close' />
      <div className='home-service-modal__panel'>
        <header className='home-service-modal__header'>
          <div className='home-service-modal__header-text'>
            <h2 id='home-service-modal-title' className='home-service-modal__title'>
              {service.title}
            </h2>
            <p className='home-service-modal__subtitle'>{service.description}</p>
          </div>
          <div className='home-service-modal__actions'>
            <Link to={service.path} onClick={onClose}>
              <Button type='text' icon={<ExpandOutlined />} className='home-service-modal__action-btn'>
                Open full page
              </Button>
            </Link>
            <Button
              type='text'
              icon={<CloseOutlined />}
              onClick={onClose}
              className='home-service-modal__action-btn home-service-modal__close'
              aria-label='Close'
            />
          </div>
        </header>
        <div className='home-service-modal__body'>
          <Suspense
            fallback={
              <div className='home-service-modal__loading'>
                <Spin size='large' />
              </div>
            }
          >
            {ServiceComponent ? <ServiceComponent /> : null}
          </Suspense>
        </div>
      </div>
    </div>,
    document.body,
  );
}

export default HomeServiceModal;
